import React, { useState, useEffect, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import { loginw } from "./api/user";
import { getToken, setToken } from "./utils/auth";
import "./App.scss";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
// 延迟加载 Layouts
const Layouts = React.lazy(() => import("./layouts"));

dayjs.locale("zh-cn");

function App() {
  const [tokenReady, setTokenReady] = useState(false);

  useEffect(() => {
    const initializeApp = async () => {
      // 检查是否有现有 token
      const existingToken = getToken();
      if (existingToken) {
        setTokenReady(true);
        return;
      }

      // 如果没有现有 token，获取新 token
      try {
        const res = await loginw();
        if (res.code === 200) {
          setToken(res.data.Authorization);
        }
      } catch (error) {
        console.error("获取 token 失败:", error);
      }
      setTokenReady(true);
    };

    initializeApp();
  }, []);

  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <div>
          {tokenReady ? (
            <Suspense fallback={<div>加载中...</div>}>
              <Switch>
                <Route
                  path="/"
                  exact
                  render={() => <Redirect to="/layouts" />}
                />
                <Route path="/layouts" component={Layouts} />
              </Switch>
            </Suspense>
          ) : (
            <div>加载中...</div>
          )}
        </div>
      </Router>
    </ConfigProvider>
  );
}

export default App;
